import { render } from "./tongji.vue?vue&type=template&id=87db3858&scoped=true&ts=true"
import script from "./tongji.vue?vue&type=script&lang=ts"
export * from "./tongji.vue?vue&type=script&lang=ts"

import "./tongji.vue?vue&type=style&index=0&id=87db3858&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87db3858"]])

export default __exports__